import _ from 'lodash';
import Fuse from 'fuse.js';

import HitTypes from 'models/search/hit_types';

export default class SnippetSearchService {
  constructor(pubsub, getDatabase) {
    this.pubsub = pubsub;
    this.getDatabase = getDatabase;
  }

  createFuse(snippets) {
    let keys = [
      { name: 'description', weight: 0.1 },
      { name: 'name', weight: 0.5 },
      { name: 'subject', weight: 0.2 },
      { name: `content.anyChannel.bodyHtml`, weight: 0.1 },
      { name: `content.info.bodyHtml`, weight: 0.1 },
    ];

    let fuseOptions = {
      caseSensitive: false,
      distance: 0,
      findAllMatches: true,
      includeScore: false,
      keys,
      location: 0,
      matchAllTokens: true,
      maxPatternLength: 32,
      minMatchCharLength: 2,
      shouldSort: true,
      threshold: 0.1,
      tokenize: true,
    };

    return new Fuse(snippets, fuseOptions);
  }

  request(orgId, envelope) {
    let text = envelope.payload.query.text;
    let snippets = this.getDatabase(orgId).snippets;
    let fuse = this.createFuse(snippets);
    let searchSnippets = text ? fuse.search(text) : snippets;
    let hits = _.map(searchSnippets, snippet => _.merge(snippet, { type: HitTypes.SNIPPET }));

    return createSnippetSearchDto(envelope.correlationId, text, hits);
  }

  publish(topic, message) {
    this.pubsub.publish(topic, message);
  }
}

function createSnippetSearchDto(id, text, hits) {
  return {
    id,
    hits,
    query: {
      text,
      from: 0,
      size: hits.length,
    },
  };
}



// WEBPACK FOOTER //
// ./src/scripts/infrastructure/backends/fake_backend/snippet_search_service.js